function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21 1.00914C20.1294 1.62321 19.1656 2.09288 18.1455 2.40005C17.5979 1.77051 16.8703 1.32432 16.0609 1.1218C15.2516 0.919287 14.3995 0.970228 13.6201 1.26774C12.8406 1.56524 12.1713 2.09496 11.7027 2.78525C11.2341 3.47553 10.9888 4.29308 11 5.12732V6.03641C9.40239 6.07784 7.81934 5.72352 6.39183 5.005C4.96431 4.28649 3.73665 3.22608 2.81818 1.91823C2.81818 1.91823 -0.818182 10.1001 7.36364 13.7364C5.49139 15.0073 3.26105 15.6445 1 15.5546C9.18182 20.1 19.1818 15.5546 19.1818 5.10005C19.181 4.84683 19.1566 4.59423 19.1091 4.34551C20.0369 3.4305 20.6917 2.27524 21 1.00914V1.00914Z",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgIconTwitter1 = function SvgIconTwitter1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTwitter1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-twitter-1.8c18364d.svg";
export { ForwardRef as ReactComponent };